import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import Buttons from '../Common/Buttons';
import Ticks from '../Common/Ticks';
import Lottie from 'react-lottie';
// import { Player, Controls } from '@lottiefiles/react-lottie-player';
import animationDataOne from '../../animations/animation.json';
import animationFunction from '../Common/animationFunction';
import { useLocale } from '../../localization/LocaleContext';

function Banner(){
    const { t, toLocalizedPath } = useLocale();
    const defaultOptions = {
        loop:true,
        autoplay:true,
        animationData:animationDataOne,
        rendererSettings:{
            preserveAspectRation:"xMidYMid slice"
        }
    }
    useEffect(() => {
        animationFunction('animation-div')
    }, [])
    return(
        <section className="home-banner sp-60 height-70 tab-height flex-center-align flex-column">
                <div className="container">
                    <div className="row flex-column-reverse column-reverse flex-lg-row">
                        <div className="col-lg-6 animation-div">
                           <h1 className="h-1 h-bold mb-20 res-margin">{t('home.heroTitleStart')} <span className="span-color">{t('home.heroTitleHighlight')}</span> <br/>{t('home.heroTitleEnd')} </h1>
                           <p className="paragraph p-adjustment mb-30 w-80">{t('home.heroDescription')}</p>
                                <Buttons/>
                           <div className="mt-20 mb-20 hero-cta-row">
                               <button className="invoice-generator-btn" onClick={() => document.getElementById('see-it-in-action').scrollIntoView({ behavior: 'smooth' })}>
                                       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                       </svg>
                                       {t('home.invoiceGeneratorCta')}
                               </button>
                               <button className="ai-estimator-btn" onClick={() => document.getElementById('ai-estimator').scrollIntoView({ behavior: 'smooth' })}>
                                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                   </svg>
                                   {t('home.aiEstimatorCta')}
                               </button>
                           </div>
                           <p className="paragraph p-adjustment m-30-0">{t('home.termsIntro')} <span className="span-color"><Link to={toLocalizedPath('termsOfService')}>{t('home.termsLabel')}</Link></span>{t('home.termsAnd')}<br/><span className="span-color"><Link to={toLocalizedPath('privacyPolicy')}>{t('home.privacyLabel')}</Link></span></p>
                          <Ticks/>
                         </div>

                        <div className="col-lg-6 flex-align-center res-h-40">
                                <Lottie options={defaultOptions} height={'auto'} width={'100%'} />
                                {/* <Player
                                    autoplay
                                    loop
                                    src="https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json"
                                    style={{ height: 'auto', width: 'auto' }}
                                    >
                                    <Controls visible={true} buttons={['play', 'repeat', 'frame', 'debug']} />
                                </Player> */}
                        </div>
                    </div>
                </div>
            </section>
    )
}
export default Banner;